/*!
 * sfx-popup.js
 * Newsletter-Fullscreen-Popup - shop-neutrale Vorlage (gebaut auf Shopify Horizon)
 * Keine externen Skripte/CDNs, keine jQuery-/Theme-JS-Abhaengigkeit.
 * Klaviyo-Anbindung ausschliesslich per fetch().
 */
(function () {
  'use strict';

  var STORAGE_CLOSED = 'sfxPop.geschlossen';
  var STORAGE_SUBSCRIBED = 'sfxPop.angemeldet';

  /* ------------------------------------------------------------------ *
   * Storage-Helfer: localStorage zuerst, Cookie-Fallback falls es wirft.
   * Try/catch um JEDEN Zugriff.
   * ------------------------------------------------------------------ */
  function cookieGet(name) {
    try {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1') + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function cookieSet(name, value) {
    try {
      var maxAge = 60 * 60 * 24 * 400; // 400 Tage (Cookie-Obergrenze)
      document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
    } catch (e) {
      /* ignorieren */
    }
  }

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return cookieGet(key);
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      cookieSet(key, value);
    }
  }

  /* ------------------------------------------------------------------ *
   * Grund-Setup
   * ------------------------------------------------------------------ */
  /* Es kann mehr als einen Popup-Container auf der Seite geben (die globale
     Sektion aus theme.liquid und eine Instanz in einem Seiten-Template). Dann
     wird auch das Skript mehrfach eingebunden und ausgefuehrt. Ohne Absicherung
     haengen dadurch zwei Listener am selben Button - ein Klick toggelt die
     Auswahl zweimal und hebt sie damit wieder auf (live beobachtet: 'interessen'
     kam leer an). Deshalb greift sich jeder Skriptlauf den ersten NOCH NICHT
     initialisierten Container und markiert ihn. */
  var root = document.querySelector('.sfx-pop:not([data-sfx-init])');
  if (!root) { return; }
  root.setAttribute('data-sfx-init', '1');

  /* Config aus dem EIGENEN Container lesen - eine feste id waere bei zwei
     Instanzen doppelt vergeben und getElementById lieferte immer die erste. */
  var cfgScript = document.getElementById('sfxPopCfg-' + (root.getAttribute('data-section-id') || ''))
    || document.getElementById('sfxPopCfg');
  var cfg = {};
  try {
    cfg = cfgScript ? JSON.parse(cfgScript.textContent || cfgScript.innerText || '{}') : {};
  } catch (e) {
    cfg = {};
  }
  cfg.publicKey = cfg.publicKey || '';
  cfg.listId = cfg.listId || '';
  cfg.modus = cfg.modus || 'anmeldung';
  cfg.triggerSeconds = Number(cfg.triggerSeconds || 0);
  cfg.pauseDays = Number(cfg.pauseDays || 14);

  var panel = root.querySelector('.sfx-pop__panel');
  var closeBtn = root.querySelector('[data-sfx-close]');
  var media = root.querySelector('[data-sfx-media]');
  var img = root.querySelector('.sfx-pop__img');
  var stepIndicator = root.querySelector('[data-sfx-stepindicator]');
  var steps = {
    1: root.querySelector('[data-sfx-step="1"]'),
    2: root.querySelector('[data-sfx-step="2"]'),
    3: root.querySelector('[data-sfx-step="3"]')
  };
  var optionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-sfx-option]'));
  var nextBtn = root.querySelector('[data-sfx-next="1"]');
  var errorStep1 = root.querySelector('[data-sfx-error="1"]');
  var form = root.querySelector('[data-sfx-form]');
  var emailInput = root.querySelector('[data-sfx-email]');
  var honeypot = root.querySelector('[data-sfx-hp]');
  var errorStep2 = root.querySelector('[data-sfx-error="2"]');
  var submitBtn = root.querySelector('[data-sfx-submit]');
  var consentBlock = root.querySelector('[data-sfx-consent]');
  var thanksHeading = root.querySelector('[data-sfx-thanks-heading]');
  var thanksText = root.querySelector('[data-sfx-thanks-text]');

  var EMAIL_PATTERN = /^[^@\s]+@[^@\s.]+\.[^@\s]{2,}$/;

  var state = {
    open: false,
    step: 1,
    lastFocused: null,
    hasBeenClosedThisView: false,
    submitted: false,
    exitIntentUsed: false
  };

  /* ------------------------------------------------------------------ *
   * dataLayer + Klaviyo-Events (blockieren den Ablauf nie)
   * ------------------------------------------------------------------ */
  function pushDataLayer(aktion, schritt) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'sfx_popup', aktion: aktion, schritt: schritt });
    } catch (e) {
      /* ignorieren */
    }
  }

  function trackEvent(metricName, properties) {
    /* Nur nach erfolgreicher Anmeldung senden: Klaviyo lehnt Events ohne Profil-Kennung
       mit 400 ab (live gemessen 2026-09-14), und eine getippte, aber nicht abgeschickte
       E-Mail soll Klaviyo nicht erreichen. 'angezeigt'/'geschlossen' gehen nur in den dataLayer. */
    if (!state.submitted) { return; }
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(cfg.publicKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: metricName } } },
              properties: properties || {},
              profile: { data: { type: 'profile', attributes: emailInput && emailInput.value ? { email: emailInput.value } : {} } }
            }
          }
        })
      }).catch(function () {});
    } catch (e) {
      /* niemals den Ablauf blockieren */
    }
  }

  /* ------------------------------------------------------------------ *
   * Step-Anzeige
   * ------------------------------------------------------------------ */
  function showStep(n) {
    state.step = n;
    [1, 2, 3].forEach(function (i) {
      if (!steps[i]) { return; }
      if (i === n) { steps[i].removeAttribute('hidden'); } else { steps[i].setAttribute('hidden', ''); }
    });
    if (stepIndicator) { stepIndicator.textContent = n + ' / 3'; }
    focusFirstInStep(n);
  }

  function focusFirstInStep(n) {
    var container = steps[n];
    if (!container) { return; }
    var focusable = getFocusable(container)[0];
    if (focusable) { focusable.focus(); }
  }

  /* ------------------------------------------------------------------ *
   * Fokus-Falle
   * ------------------------------------------------------------------ */
  function isVisible(el) {
    // Layout-unabhaengige Sichtbarkeitspruefung (funktioniert auch ohne echte
    // Renderingpipeline, z. B. in Test-Umgebungen ohne Layout-Engine):
    // ein Element gilt als unsichtbar, wenn ein Vorfahre [hidden] traegt.
    var node = el;
    while (node && node !== document) {
      if (node.hasAttribute && node.hasAttribute('hidden')) { return false; }
      node = node.parentNode;
    }
    return true;
  }

  function getFocusable(scope) {
    // Hinweis: die tabindex="-1"-Pruefung erfolgt separat im Filter, da sie
    // sonst nur fuer die letzte Selektor-Alternative gelten wuerde (z. B.
    // waere der Honeypot mit tabindex="-1" sonst trotzdem ueber
    // "input:not([disabled])" enthalten).
    var selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]';
    return Array.prototype.slice.call((scope || panel).querySelectorAll(selector)).filter(function (el) {
      if (el.getAttribute('tabindex') === '-1') { return false; }
      return isVisible(el);
    });
  }

  function handleFocusTrap(e) {
    if (!state.open || e.key !== 'Tab') { return; }
    var focusable = getFocusable(panel);
    if (!focusable.length) { return; }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first || !panel.contains(document.activeElement)) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last || !panel.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function handleKeydown(e) {
    if (!state.open) { return; }
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      close('esc');
      return;
    }
    handleFocusTrap(e);
  }

  /* ------------------------------------------------------------------ *
   * Oeffnen / Schliessen
   * ------------------------------------------------------------------ */
  function open(reason) {
    if (state.open) { return; }
    if (img && !img.getAttribute('src') && img.getAttribute('data-src')) {
      img.setAttribute('src', img.getAttribute('data-src'));
    }
    root.removeAttribute('hidden');
    state.open = true;
    try {
      document.documentElement.classList.add('sfx-noscroll');
      document.body.classList.add('sfx-noscroll');
    } catch (e) {}
    state.lastFocused = document.activeElement;
    showStep(state.step || 1);
    document.addEventListener('keydown', handleKeydown, true);
    trackEvent('Popup angezeigt', { grund: reason || '' });
    pushDataLayer('angezeigt', state.step);
  }

  function close(reason) {
    if (!state.open) { return; }
    root.setAttribute('hidden', '');
    state.open = false;
    state.hasBeenClosedThisView = true;
    try {
      document.documentElement.classList.remove('sfx-noscroll');
      document.body.classList.remove('sfx-noscroll');
    } catch (e) {}
    storageSet(STORAGE_CLOSED, String(Date.now()));
    document.removeEventListener('keydown', handleKeydown, true);
    trackEvent('Popup geschlossen', { schritt: state.step, grund: reason || '' });
    pushDataLayer('geschlossen', state.step);
    if (state.lastFocused && typeof state.lastFocused.focus === 'function') {
      state.lastFocused.focus();
    }
  }

  if (closeBtn) { closeBtn.addEventListener('click', function () { close('close-button'); }); }
  root.addEventListener('click', function (e) {
    if (e.target === root) { close('backdrop'); }
  });

  /* ------------------------------------------------------------------ *
   * Schritt 1 - Interessen (Mehrfachauswahl)
   * ------------------------------------------------------------------ */
  function getSelectedInteressen() {
    return optionButtons
      .filter(function (btn) { return btn.classList.contains('is-selected'); })
      .map(function (btn) { return btn.getAttribute('data-key'); });
  }

  function updateNextButtonState() {
    if (!nextBtn) { return; }
    var hasSelection = getSelectedInteressen().length > 0;
    nextBtn.disabled = !hasSelection;
    if (hasSelection && errorStep1) { errorStep1.setAttribute('hidden', ''); }
  }

  /* Zwei Auswahlarten:
     'einfach'  (Standard) - ein Klick waehlt genau ein Ziel und fuehrt sofort zu
                Schritt 2. Kein Weiter-Button, ein Schritt weniger fuer den Nutzer.
     'mehrfach' - Ziele lassen sich kombinieren, Weiter-Button schliesst ab. */
  var einfachauswahl = cfg.auswahlModus !== 'mehrfach';

  optionButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (einfachauswahl) {
        optionButtons.forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        if (errorStep1) { errorStep1.setAttribute('hidden', ''); }
        showStep(2);
        return;
      }
      var selected = btn.classList.toggle('is-selected');
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      updateNextButtonState();
    });
  });

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      if (getSelectedInteressen().length === 0) {
        if (errorStep1) { errorStep1.removeAttribute('hidden'); }
        return;
      }
      showStep(2);
    });
  }

  /* ------------------------------------------------------------------ *
   * Schritt 2 - E-Mail + Praeferenzen + Consent
   * ------------------------------------------------------------------ */
  function getSelectedPraeferenzen() {
    return Array.prototype.slice.call(root.querySelectorAll('[data-sfx-pref]'))
      .filter(function (el) { return el.checked; })
      .map(function (el) { return el.getAttribute('data-key'); });
  }

  function setError2(msg) {
    if (!errorStep2) { return; }
    if (msg) {
      errorStep2.textContent = msg;
      errorStep2.removeAttribute('hidden');
    } else {
      errorStep2.setAttribute('hidden', '');
    }
  }

  function buildSubscribeBody(email, interessen, praeferenzen) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Fullscreen-Popup',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  interessen: interessen,
                  praeferenzen: praeferenzen,
                  popup_quelle: 'fullscreen-popup',
                  popup_datum: new Date().toISOString().slice(0, 10)
                }
                /* KEIN 'subscriptions'-Feld: Die Client-API (revision 2024-10-15)
                   lehnt es mit 400 ab ("'subscriptions' is not a valid field for
                   the resource 'profile'"). Der Endpunkt /client/subscriptions/
                   setzt den Marketing-Consent selbst; die Liste hat Double-Opt-in,
                   der Consent wird also erst mit dem Klick in der Bestaetigungsmail
                   auf SUBSCRIBED gesetzt. Live geprueft: mit Feld 400, ohne 202. */
              }
            }
          }
        },
        /* 'relationships' MUSS direktes Kind von 'data' sein - liegt es in
           'attributes', antwortet Klaviyo mit 400 "Cannot embed relationships
           inside of attributes." Live geprueft. */
        relationships: { list: { data: { type: 'list', id: cfg.listId } } }
      }
    };
  }

  function buildUpdateBody(email, interessen, praeferenzen) {
    return {
      data: {
        type: 'profile',
        attributes: {
          email: email,
          properties: {
            interessen: interessen,
            praeferenzen: praeferenzen,
            popup_quelle: 'fullscreen-popup',
            popup_datum: new Date().toISOString().slice(0, 10)
          }
        }
      }
    };
  }

  function submitSignup(email, interessen, praeferenzen) {
    var body = buildSubscribeBody(email, interessen, praeferenzen);
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + cfg.publicKey, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (res) {
      /* WICHTIG (live nachgewiesen): /client/subscriptions/ legt bei einer Liste mit
         Double-Opt-in zwar das Profil an, speichert die uebergebenen 'properties' aber
         NICHT - am Profil steht danach nur 'company_id'. Ohne diesen zweiten Aufruf
         gingen Interessen und Praeferenzen also verloren, und genau die sind der Zweck
         des Popups. Deshalb setzen wir die Eigenschaften zusaetzlich ueber
         /client/profiles/. Der Aufruf darf das Ergebnis der Anmeldung nicht
         beeinflussen: Faellt er aus, bleibt die Anmeldung trotzdem gueltig. */
      if (res && res.status === 202) {
        submitUpdate(email, interessen, praeferenzen).catch(function () {});
      }
      return res;
    });
  }

  function submitUpdate(email, interessen, praeferenzen) {
    var body = buildUpdateBody(email, interessen, praeferenzen);
    return fetch('https://a.klaviyo.com/client/profiles/?company_id=' + cfg.publicKey, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      setError2('');

      var email = (emailInput && emailInput.value || '').trim();
      var interessen = getSelectedInteressen();
      var praeferenzen = getSelectedPraeferenzen();

      if (!EMAIL_PATTERN.test(email)) {
        setError2(root.getAttribute('data-sfx-error-email') || 'Bitte gib eine gueltige E-Mail-Adresse ein.');
        return;
      }

      // Honeypot: ausgefuellt -> so tun als ob, aber nichts senden
      if (honeypot && honeypot.value) {
        showStep(3);
        pushDataLayer('abgeschlossen', 3);
        return;
      }

      if (submitBtn) { submitBtn.disabled = true; }

      var request = cfg.modus === 'update' ? submitUpdate(email, interessen, praeferenzen) : submitSignup(email, interessen, praeferenzen);

      request.then(function (resp) {
        if (submitBtn) { submitBtn.disabled = false; }
        var ok = cfg.modus === 'update' ? resp.ok : resp.status === 202;
        if (ok) {
          if (cfg.modus === 'update') {
            if (thanksHeading) { thanksHeading.textContent = 'Gespeichert'; }
          }
          showStep(3);
          if (cfg.modus !== 'update') {
            storageSet(STORAGE_SUBSCRIBED, 'true');
          }
          state.submitted = true;
          trackEvent('Popup abgeschlossen', { schritt: 3 });
          pushDataLayer('abgeschlossen', 3);
        } else {
          setError2(root.getAttribute('data-sfx-error-generic') || 'Da ist leider etwas schiefgelaufen. Bitte versuche es erneut.');
        }
      }).catch(function () {
        if (submitBtn) { submitBtn.disabled = false; }
        setError2(root.getAttribute('data-sfx-error-generic') || 'Da ist leider etwas schiefgelaufen. Bitte versuche es erneut.');
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * Update-Modus vorbereiten
   * ------------------------------------------------------------------ */
  function applyUpdateMode() {
    if (cfg.modus !== 'update') { return; }
    if (consentBlock) { consentBlock.setAttribute('hidden', ''); }
    if (emailInput) {
      try {
        var params = new URLSearchParams(window.location.search);
        var prefillEmail = params.get('email');
        if (prefillEmail) { emailInput.value = prefillEmail; }
      } catch (e) {}
      emailInput.setAttribute('readonly', 'readonly');
    }
  }
  applyUpdateMode();

  /* ------------------------------------------------------------------ *
   * Sperren / Ausschluesse
   * ------------------------------------------------------------------ */
  function isExcludedTemplate() {
    var excludeRaw = root.getAttribute('data-sfx-exclude') || '';
    if (!excludeRaw.trim()) { return false; }
    var pageType = (root.getAttribute('data-sfx-page-type') || '').trim().toLowerCase();
    var templateName = (root.getAttribute('data-sfx-template') || '').trim().toLowerCase();
    var list = excludeRaw.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    return list.indexOf(pageType) !== -1 || list.indexOf(templateName) !== -1;
  }

  function isWithinPause() {
    var raw = storageGet(STORAGE_CLOSED);
    if (!raw) { return false; }
    var ts = parseInt(raw, 10);
    if (!ts || isNaN(ts)) { return false; }
    var diffDays = (Date.now() - ts) / (1000 * 60 * 60 * 24);
    return diffDays < cfg.pauseDays;
  }

  function isSubscribed() {
    return storageGet(STORAGE_SUBSCRIBED) === 'true';
  }

  function hasKnownProfile() {
    var raw = cookieGet('__kla_id');
    if (!raw) { return false; }
    try {
      var decoded = atob(decodeURIComponent(raw));
      return decoded.indexOf('$email') !== -1;
    } catch (e) {
      return false;
    }
  }

  function shouldSuppress() {
    return isSubscribed() || isWithinPause() || hasKnownProfile() || isExcludedTemplate();
  }

  /* ------------------------------------------------------------------ *
   * Ausloeser
   * ------------------------------------------------------------------ */
  function isDesktopViewport() {
    try {
      return window.matchMedia('(min-width: 860px)').matches;
    } catch (e) {
      return window.innerWidth >= 860;
    }
  }

  /* Shopify-Cookie-Banner (#shopify-pc__banner, z-index 2000000) liegt sonst UEBER
     dem Popup, und die Fokus-Falle sperrt Tastatur-Nutzer vom Banner aus (live
     beobachtet, Sportster 2026-09-14). Automatische Ausloeser warten deshalb, bis
     der Banner beantwortet ist. ?popup=1 und Editor bleiben unberuehrt. */
  function cookieBannerVisible() {
    try {
      var b = document.getElementById('shopify-pc__banner');
      if (!b) { return false; }
      var r = b.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && window.getComputedStyle(b).visibility !== 'hidden';
    } catch (e) {
      return false;
    }
  }

  function openAfterCookieBanner(reason) {
    if (!cookieBannerVisible()) { open(reason); return; }
    var checks = 0;
    var iv = window.setInterval(function () {
      checks++;
      if (checks > 1800) { window.clearInterval(iv); return; } // nach 30 Min. aufgeben, nie ueberlagern
      if (cookieBannerVisible()) { return; }
      window.clearInterval(iv);
      window.setTimeout(function () {
        if (!state.hasBeenClosedThisView && !state.open) { open(reason); }
      }, 2000);
    }, 1000);
  }

  function handleExitIntent(e) {
    if (state.exitIntentUsed || state.hasBeenClosedThisView || state.open) { return; }
    if (!isDesktopViewport()) { return; }
    if (cookieBannerVisible()) { return; }
    if (e.clientY <= 0 && !e.relatedTarget) {
      state.exitIntentUsed = true;
      open('exit-intent');
    }
  }

  function setupNormalTriggers() {
    /* Aus-Schalter: Ist das Popup nicht aktiv geschaltet, wird KEIN Ausloeser
       registriert - weder Zeit noch Exit-Intent. Nur ?popup=1 oeffnet dann noch
       (Vorschau/Test). So kann die Sektion gefahrlos live liegen, bevor sie
       freigegeben ist. */
    if (!cfg.aktiv) { return; }
    if (shouldSuppress()) { return; }
    if (cfg.triggerSeconds > 0) {
      window.setTimeout(function () {
        if (!state.hasBeenClosedThisView && !state.open) { openAfterCookieBanner('timer'); }
      }, cfg.triggerSeconds * 1000);
    }
    document.addEventListener('mouseout', handleExitIntent);
  }

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function setupDesignModeListener() {
    document.addEventListener('shopify:section:select', function (evt) {
      var sectionId = root.getAttribute('data-section-id');
      if (evt && evt.detail && evt.detail.sectionId && sectionId && evt.detail.sectionId === sectionId) {
        open('editor');
      } else if (evt && evt.target && root.contains(evt.target)) {
        open('editor');
      }
    });
  }

  /* ------------------------------------------------------------------ *
   * Init
   * ------------------------------------------------------------------ */
  function init() {
    var forced = false;
    try {
      forced = new URLSearchParams(window.location.search).get('popup') === '1';
    } catch (e) {
      forced = /[?&]popup=1(&|$)/.test(window.location.search || '');
    }

    if (forced) {
      open('forced');
      return;
    }

    if (cfg.modus === 'update') {
      open('update');
      return;
    }

    if (isDesignMode()) {
      setupDesignModeListener();
      return;
    }

    setupNormalTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Fuer Tests/Diagnose zugaenglich machen (kein Teil des Kern-UX-Vertrags) */
  root.__sfxPopDebug = {
    state: state,
    cfg: cfg,
    open: open,
    close: close,
    shouldSuppress: shouldSuppress,
    isExcludedTemplate: isExcludedTemplate,
    isWithinPause: isWithinPause,
    isSubscribed: isSubscribed,
    hasKnownProfile: hasKnownProfile,
    buildSubscribeBody: buildSubscribeBody,
    buildUpdateBody: buildUpdateBody,
    EMAIL_PATTERN: EMAIL_PATTERN,
    isDesktopViewport: isDesktopViewport,
    handleExitIntent: handleExitIntent
  };
})();
